import React, { useEffect, useRef, useState } from 'react'

import type { HouseTreeNode } from '../types/catalog'
import { HouseTreeBrowser } from './HouseTreeBrowser'

interface HouseAssignmentFieldProps {
  selected: string[]
  tree: HouseTreeNode[]
  onChange: (nextSelected: string[]) => void
  isOpen: boolean
  onOpenChange: (open: boolean) => void
}

export const HouseAssignmentField: React.FunctionComponent<HouseAssignmentFieldProps> = (props) => {
  const { selected, tree, onChange, isOpen, onOpenChange } = props
  const wrapRef = useRef<HTMLDivElement | null>(null)
  const [filter, setFilter] = useState('')

  useEffect(() => {
    if (!isOpen) return undefined
    const handler = (event: MouseEvent) => {
      if (!wrapRef.current) return
      if (!wrapRef.current.contains(event.target as Node)) onOpenChange(false)
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [isOpen, onOpenChange])

  function toggle(leaf: string): void {
    if (selected.includes(leaf)) onChange(selected.filter((entry) => entry !== leaf))
    else onChange([...selected, leaf])
  }

  return (
    <div className="device-select-wrap" ref={wrapRef}>
      <input
        className="device-select-input"
        placeholder="Search houses..."
        autoComplete="off"
        spellCheck={false}
        value={filter}
        onClick={() => {
          if (!isOpen) onOpenChange(true)
        }}
        onFocus={() => {
          if (!isOpen) onOpenChange(true)
        }}
        onChange={(event) => setFilter(event.target.value)}
      />
      <div className={`device-dropdown${isOpen ? ' open' : ''}`} style={{ width: 300 }}>
        <HouseTreeBrowser
          tree={tree}
          selected={selected}
          onToggleLeaf={toggle}
          filter={filter}
        />
      </div>
    </div>
  )
}
